import * as React from 'react';
import { Search } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from "@/lib/utils";

interface TableCardProps {
  searchPlaceholder?: string;
  searchQuery?: string;
  onSearchChange?: (value: string) => void;
  headerAction?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function TableCard({
  searchPlaceholder,
  searchQuery,
  onSearchChange,
  headerAction,
  children,
  className,
}: TableCardProps) {
  const hasHeader = searchPlaceholder || headerAction;

  return (
    <Card className={cn('py-0 gap-0', className)}>
      {hasHeader && (
        <div className="flex items-center justify-end gap-2 px-4 pt-3">
          {searchPlaceholder && onSearchChange && (
            <div className="relative">
              <Search className="text-muted-foreground/50 pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2" />
              <input
                type="search"
                placeholder={searchPlaceholder}
                className="placeholder:text-muted-foreground/50 border-border/50 hover:border-border focus:border-border h-8 w-full rounded-md border bg-transparent pl-8 pr-3 text-sm outline-none transition-colors sm:w-[200px] md:w-[250px]"
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </div>
          )}
          {headerAction}
        </div>
      )}
      <CardContent className="p-3">{children}</CardContent>
    </Card>
  );
}
